import script from "./ZhinengGG.vue?vue&type=script&setup=true&lang=js"
export * from "./ZhinengGG.vue?vue&type=script&setup=true&lang=js"

import "./ZhinengGG.vue?vue&type=style&index=0&id=44974804&lang=less&scoped=true"
script.__scopeId = "data-v-44974804"

export default script